<div class="sidenav_container left-sidebar " *ngIf="isLoaded" >
  <div fxLayout="column" fxLayoutGap="10px">
    <mat-nav-list>
      <mat-tree
        [dataSource]="dataSource"
        [treeControl]="treeControl"
        class="mat-drop-tree"
      >
        <mat-tree-node
          *matTreeNodeDef="let node"
          matTreeNodePadding
          class="parent-tree-content float-left cursor-pointer"
          [routerLink]="node.route"
          routerLinkActive="active"
          matRipple
        >
         <span class="submenu-icon"></span> 
          {{ node.name }}
        </mat-tree-node>

        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding
          class="justify-content-center float-left w-100"
        >
          <button
            mat-icon-button
            matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.name"
            class="w-100 text-left"
          >
            <mat-icon class="mat-icon-rtl-mirror">
              {{
                treeControl.isExpanded(node) ? "expand_more" : "chevron_right"
              }}
            </mat-icon>
            {{ node.name }}
          </button>
        </mat-tree-node>
      </mat-tree>
    </mat-nav-list>
  </div>
</div>
